import { render, staticRenderFns } from "./InsertCustomBank.vue?vue&type=template&id=5d63896a"
import script from "./InsertCustomBank.vue?vue&type=script&lang=js"
export * from "./InsertCustomBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports